import React from "react";
import { Link } from "react-router-dom";
import { RiMicrosoftLoopFill } from "react-icons/ri";

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "hidden" }) => {
  return (
    <Link to="/" className="flex cursor-pointer items-center gap-2">
      <RiMicrosoftLoopFill className="text-3xl text-primary" />
      <span className={`${className} text-2xl font-bold`}>XKicks.</span>
    </Link>
  );
};

export default Logo;
